module.exports = __webpack_public_path__ + "static/img/thoracicPain_1.175b09a3.png";